
            const data = {"name":"loupe","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" class=\"loupe-svg\" d=\"m20 20-5-5m2-5a7.001 7.001 0 0 1-11.95 4.95A7 7 0 1 1 17 10Z\" _stroke=\"#81889B\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    